import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./NavBar.css";

function NavBar() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const { i18n } = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    return (
        <nav className="navbar">
            <div className="navbar-brand">
                <img src="/icon.png" alt="NeuroPlus Logo" className="navbar-logo" />
                NeuroPlus
            </div>

            <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className={`navbar-links ${menuOpen ? "open" : ""}`}>
                <Link
                    to="/how-to-delete"
                    className={`nav-link ${location.pathname === "/" || location.pathname === "/how-to-delete"
                            ? "active"
                            : ""
                        }`}
                    onClick={() => setMenuOpen(false)}
                >
                    How To Delete
                </Link>
                <Link
                    to="/privacy-policy"
                    className={`nav-link ${location.pathname === "/privacy-policy" ? "active" : ""
                        }`}
                    onClick={() => setMenuOpen(false)}
                >
                    Privacy Policy
                </Link>

                <div className="lang-switcher">
                    <button
                        className={`lang-btn ${i18n.language === "en" ? "active" : ""}`}
                        onClick={() => changeLanguage("en")}
                    >
                        EN
                    </button>
                    <span className="lang-divider">|</span>
                    <button
                        className={`lang-btn ${i18n.language === "fr" ? "active" : ""}`}
                        onClick={() => changeLanguage("fr")}
                    >
                        FR
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;